module.exports = __webpack_public_path__ + "img/operation-disabled.1d83ad13.png";